import {
  SendEstraFormResponse,
  sendNewsletter,
  SendNewsletterPayload,
} from 'app/api/estraForm'
import { AxiosError } from 'axios'
import { ApiError } from 'EstraSponsor'
import { useMutation, UseMutationResult } from 'react-query'

export const useSendNewsletter = (): UseMutationResult<
  SendEstraFormResponse,
  AxiosError<ApiError>,
  SendNewsletterPayload
> => {
  return useMutation(sendNewsletter)
}
